import { FC, ReactNode } from 'react';
import styles from './InfoCallout.module.scss';

export interface InfoCalloutProps {
  variant?: 'status' | 'why' | 'note' | 'warning';
  title?: string;
  isHome?: boolean;
  children: ReactNode;
}

export const InfoCallout: FC<InfoCalloutProps> = ({
  variant = 'note',
  title,
  isHome = false,
  children,
}) => {
  if (variant === 'warning') {
    return (
      <div className={`${styles.callout} ${styles.warning} ${isHome ? styles.homeWarning : ''}`} role="region" aria-label={title || "Warning"}>
        <div className={styles.icon} aria-hidden="true">
          ⚠️
        </div>
        <div className={styles.body}>
          {title && <h4 className={styles.title}>{title}</h4>}
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    );
  }

  if (variant === 'why') {
    return (
      <div className={`${styles.callout} ${styles.why}`} role="region" aria-label={title}>
        <div className={styles.icon} aria-hidden="true">
          ℹ
        </div>
        <div className={styles.body}>
          {title && <h4 className={styles.title}>{title}</h4>}
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    );
  }

  if (variant === 'status') {
    return (
      <div className={`${styles.callout} ${styles.status}`} role="region" aria-label={title}>
        {title && <h3 className={styles.title}>{title}</h3>}
        <div className={styles.content}>{children}</div>
      </div>
    );
  }

  return (
    <div className={`${styles.callout} ${styles.note}`} role="note">
      {title && <h4 className={styles.title}>{title}</h4>}
      <div className={styles.content}>{children}</div>
    </div>
  );
};
